export function Marquee({ items }) {
    const loop = [...items, ...items];
    return (
        <div className="marquee" aria-label="Services RESET365" data-testid="reset365-marquee">
            <div className="marquee__track">
                {loop.map((item, index) => (
                    <span className="marquee__item" key={`${item}-${index}`}>
                        {item}<b aria-hidden="true">+</b>
                    </span>
                ))}
            </div>
        </div>
    );
}
